import { processParamsToHeaders } from "@/functions/helpers/serviceHelper";
import authHeader from "./auth-header";
import axiosInstance from "./instance";

class KpiService {
  getDashboardList(params) {
    const { headers, params: newParams } = processParamsToHeaders(params);
    return axiosInstance.get("/dashboard_kpi_list", {
      params: newParams,
      headers: { ...headers, ...authHeader() },
    });
  }

  getDashboardKpi(params) {
    const { headers, params: newParams } = processParamsToHeaders(params);
    return axiosInstance.get("/dashboard_kpi_data", {
      params: newParams,
      headers: { ...headers, ...authHeader() },
    });
  }

  getServerList(params) {
    const { headers, params: newParams } = processParamsToHeaders(params);
    return axiosInstance.get("/server_kpi_list", {
      params: newParams,
      headers: { ...headers, ...authHeader() },
    });
  }

  getServerKpi(params) {
    const { headers, params: newParams } = processParamsToHeaders(params);
    return axiosInstance.get("/server_kpi_data", {
      params: newParams,
      headers: { ...headers, ...authHeader() },
    });
  }

  getYearKPIPDF(params) {
    const data = {
      maintainer: params?.maintainer ?? null,
      ship_id: params?.ship_id ?? null,
      year: params?.year ?? null,
    };
    return axiosInstance.post("/get_year_kpi_report", data, {
      responseType: "blob",
      headers: authHeader(),
    });
  }
  getImporterKpi(params) {
    const { headers } = processParamsToHeaders(params);
    return axiosInstance.get("/importer_kpi", {
      params: {
        date_from: params?.dateFrom ?? null,
        date_to: params?.dateTo ?? null,
        maintainer: params?.maintainer ?? null,
      },
      headers: { ...headers, ...authHeader() },
    });
  }

  getActivationTimeKpi(params) {
    const { headers } = processParamsToHeaders(params);
    return axiosInstance.get("/activation_time_kpi_by_owner", {
      params: {
        date_from: params?.dateFrom ?? null,
        date_to: params?.dateTo ?? null,
        maintainer: params?.maintainer ?? null,
      },
      headers: { ...headers, ...authHeader() },
    });
  }

  getOwnersAndShipsKpi(params) {
    const { headers } = processParamsToHeaders(params);
    return axiosInstance.get("/owners_and_ships_kpi", {
      params: {
        date_from: params?.dateFrom ?? null,
        date_to: params?.dateTo ?? null,
        maintainer: params?.maintainer ?? null,
        kpi: params?.kpi ?? null,
      },
      headers: { ...headers, ...authHeader() },
    });
  }

  getWatchdogShipKpi(params) {
    const { headers } = processParamsToHeaders(params);
    return axiosInstance.get("/watchdog_kpi_per_ship", {
      params: {
        maintainer: params?.maintainer ?? null,
        owner: params?.ownerId ?? null,
        ship_imo: params?.shipImo ?? null,
        start_time: params?.dateFrom ?? null,
        end_time: params?.dateTo ?? null,
        ship_id: params?.shipId ?? null,
      },
      headers: { ...headers, ...authHeader() },
    });
  }

  getWatchdogKpiExclusions(params) {
    return axiosInstance.get("/watchdog_kpi_exclusions", {
      params: {
        owner_id: params?.shipImo ?? null,
        ship_imo: params?.shipImo ?? null,
      },
      headers: authHeader(),
    });
  }
  getWatchdogKpiExclusionsV2(params) {
    return axiosInstance.get("/v2/watchdog_exclusions", {
      params,
      headers: authHeader(),
    });
  }

  updateWatchdogKpiExclusions(params) {
    const data = {
      id: params?.id ?? null,
      start_time: params?.startTime ?? null,
      end_time: params?.endTime ?? null,
      description: params?.description ?? null,
      deleted: params?.deleted ?? null,
      ship_imo: params?.shipImo ?? null,
      owner_id: params?.ownerId ?? null,
      maintainer: params?.maintainer ?? null,
      tickets: params?.tickets ?? null,
      exclusion_id: params?.exclusion_id ?? null,
    };

    return axiosInstance.put("/watchdog_kpi_exclusions", data, {
      headers: authHeader(),
    });
  }
  updateWatchdogKpiExclusionsV2(params) {
    return axiosInstance.put("/v2/watchdog_exclusions", params, {
      headers: authHeader(),
    });
  }

  createWatchdogKpiExclusions(params) {
    const data = {
      owner_id: params?.ownerId ?? null,
      ship_imo: params?.shipImo ?? null,
      start_time: params?.startTime?.toString() ?? null,
      end_time: params?.endTime ?? null,
      description: params?.description ?? null,
      maintainer: params?.maintainer ?? null,
      tickets: params?.tickets ?? null,
      exclusion_id: params?.exclusion_id ?? null,
    };

    return axiosInstance.post("/watchdog_kpi_exclusions", data, {
      headers: authHeader(),
    });
  }
  createWatchdogKpiExclusionsV2(params) {
    return axiosInstance.post("/v2/watchdog_exclusions", params, {
      headers: authHeader(),
    });
  }

  deleteWatchdogKpiExclusionsV2(params) {
    return axiosInstance.post("/v2/delete_watchdog_exclusions", params, {
      headers: authHeader(),
    });
  }

  createServicesExclusions(params) {
    return axiosInstance.post("/watchdog_services_exclusions", params, {
      headers: authHeader(),
    });
  }

  getTorquemeterFaultDetection(params) {
    return axiosInstance.get("/torquemeter_fault_detection", {
      params,
      headers: authHeader(),
    });
  }

  getShipKpiDataHeatMap(params) {
    const { headers, params: newParams } = processParamsToHeaders(params);
    return axiosInstance.get("/get_ship_kpi_heatmap", {
      params: newParams,
      headers: { ...headers, ...authHeader() },
    });
  }

  getKPIDefinitions(params) {
    return axiosInstance.get("/kpi_definitions", {
      params,
      headers: authHeader(),
    });
  }

  getYearKPIs(params) {
    return axiosInstance.get("/get_year_kpis", {
      params,
      headers: authHeader(),
    });
  }

  getYearMaintainerKPIs(params) {
    return axiosInstance.get("/get_year_maintainer_kpis", {
      params,
      headers: authHeader(),
    });
  }

  calculateYearKpi(params) {
    return axiosInstance.post("/calculate_year_kpi", params, {
      headers: authHeader(),
    });
  }

  confirmYearKpi(params) {
    return axiosInstance.post("/confirm_year_kpi", params, {
      headers: authHeader(),
    });
  }

  getCalculateYearKpiAllCSV(params) {
    return axiosInstance.post("/calculate_year_kpi_all", params, {
      responseType: "blob",
      headers: authHeader(),
    });
  }

  getDataVerificationShipKpi(params) {
    return axiosInstance.get("/data_verification/kpi_per_ship", {
      params: {
        maintainer: params?.maintainer ?? null,
        ship_id: params?.shipId ?? null,
        owner: params?.ownerId ?? null,
        ship_imo: params?.shipImo ?? null,
        start_time: params?.dateFrom ?? null,
        end_time: params?.dateTo ?? null,
        kpi: params?.kpi ?? null,
      },
      headers: authHeader(),
    });
  }

  getDataVerificationKpiConfig(params) {
    return axiosInstance.get("/data_verification/config", {
      params: {
        maintainer: params?.maintainer ?? null,
        ship_id: params?.shipId ?? null,
      },
      headers: authHeader(),
    });
  }

  saveDataVerificationKpiConfig(params) {
    return axiosInstance.post(
      "/data_verification/config",
      {
        maintainer: params?.maintainer ?? null,
        ship_id: params?.shipId ?? null,
        config: params?.config ?? null,
      },
      {
        headers: authHeader(),
      }
    );
  }

  recalculateDataVerificationKpiShipData(params) {
    return axiosInstance.post(
      "/data_verification/recalculate_ship",
      {
        maintainer: params?.maintainer ?? null,
        ship_id: params?.shipId ?? null,
        days: params?.days ?? null,
      },
      {
        headers: authHeader(),
      }
    );
  }

  async downloadReportPDF(params, filenameGenerator = null) {
    const response = await this.getYearKPIPDF(params);
    const href = URL.createObjectURL(response.data);

    const filename =
      (filenameGenerator && typeof filenameGenerator === "function"
        ? filenameGenerator(params) ?? "report"
        : `report_${params.year ?? ""}_${params.maintainer ?? ""}_${
            params.ship_name ?? ""
          }`
      ).replace(/[^a-z0-9_-]/gi, "_") + ".pdf";
    const link = Object.assign(document.createElement("a"), {
      href,
      download: filename,
    });
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  async downloadYearKpiAllCSV(params, filenameGenerator = null) {
    const response = await this.getCalculateYearKpiAllCSV(params);
    const href = URL.createObjectURL(response.data);

    const filename =
      (filenameGenerator && typeof filenameGenerator === "function"
        ? filenameGenerator(params) ?? "results"
        : `results_${params.year ?? ""}_${params.maintainer ?? ""}`
      ).replace(/[^a-z0-9_-]/gi, "_") + ".csv";
    const link = Object.assign(document.createElement("a"), {
      href,
      download: filename,
    });
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }
}

export default new KpiService();
